import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ClockIcon, ShieldCheckIcon, StethoscopeIcon } from 'lucide-react';
import { clinic, highlights, images } from '../../data/clinic';
const choices = [{
  label: 'Pijnbehandelingen',
  text: 'Kies waar u pijn heeft en bekijk de behandelingen',
  to: '#waar-pijn',
  kind: 'hash'
}, {
  label: 'Behandelingen',
  text: 'Ons volledige behandelaanbod met patiëntenfolders',
  to: '/behandelingen',
  kind: 'route'
}, {
  label: 'Ik ben verwijzer',
  text: 'Een patiënt doorverwijzen naar onze kliniek',
  to: '/verwijzers',
  kind: 'route'
}] as const;
const highlightIcons = [ClockIcon, ShieldCheckIcon, StethoscopeIcon];
export function HomeHero() {
  return <section className="bg-white" data-id="element-97" data-mp="2s2d8eedo9i49">
      <div className="relative" data-id="element-98" data-mp="2s1k6prtklisz">
        <img src={images.reception} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-99" data-mp="3ft961s4t77jf" />
        <div className="absolute inset-0 bg-ink/75" aria-hidden="true" data-id="element-100" data-mp="3kjfvfu75aw2q" />
        <div className="relative mx-auto grid max-w-7xl gap-10 px-5 pb-32 pt-20 lg:min-h-[640px] lg:grid-cols-[1.15fr_1fr] lg:items-center lg:gap-16 lg:px-8 lg:pb-44 lg:pt-32" data-id="element-101" data-mp="3klit90ejhti0">
          <div className="text-white" data-id="element-102" data-mp="jxp8ztjgl6tl">
            <p className="font-display text-base font-medium text-cyan" data-id="element-103" data-mp="xnamioehotu8">Pijncentrum Velsen-Noord</p>
            <h1 className="mt-4 font-display text-[2.6rem] font-semibold leading-[1.04] tracking-tight sm:text-6xl lg:text-7xl" data-id="element-104" data-mp="sx2mqyem8hk4">
              Uw pijn, is onze zorg
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/80" data-id="element-105" data-mp="17njoyjz2rbi2">
              Onafhankelijk specialistisch pijnbehandelcentrum. De behandelingen worden uitgevoerd door
              anesthesioloog-pijnspecialisten en (pijn)verpleegkundigen.
            </p>
            <a href={clinic.phoneHref} className="mt-8 inline-flex flex-wrap items-center gap-x-3 gap-y-1 text-white/80 transition-colors duration-150 hover:text-white" data-id="element-106" data-mp="1clbh9f3mszms">
              <span className="text-sm" data-id="element-107" data-mp="3ee9ctiosm6bf">Bel ons</span>
              <span className="font-display text-2xl font-semibold text-white" data-id="element-108" data-mp="1hcbz6vulg4pp">{clinic.phone}</span>
            </a>
          </div>

          <div className="rounded-3xl bg-white p-3 shadow-[0_30px_60px_-30px_rgba(0,0,0,0.5)]" data-id="element-109" data-mp="1mb58sd6rfbkl">
            <p className="px-4 pb-2 pt-3 font-display text-lg font-semibold text-ink" data-id="element-110" data-mp="1r8588593tg2q">Waarover wilt u meer weten?</p>
            <ul data-id="element-111" data-mp="1w6q8u5s9q1rp">
              {choices.map(choice => {
              const content = <>
                    <span className="min-w-0 flex-1" data-id="element-112" data-mp="259hka5l58xjc">
                      <span className="block font-display text-[17px] font-semibold text-ink group-hover:text-primary" data-id="element-113" data-mp="257wqwjakfkn2">
                        {choice.label}
                      </span>
                      <span className="mt-0.5 block text-sm text-muted" data-id="element-114" data-mp="2exzhkcu7smi8">{choice.text}</span>
                    </span>
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-soft text-primary transition-colors duration-150 group-hover:bg-primary group-hover:text-white" data-id="element-115" data-mp="2jzyjrje7xddl">
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-116" data-mp="caj1hq67x3l2" />
                    </span>
                  </>;
              const cls = 'group flex items-center gap-4 rounded-2xl px-4 py-4 transition-colors duration-150 hover:bg-surface';
              return <li key={choice.label} data-id="element-117" data-mp="3ukcwgxhq0wni">
                    {choice.kind === 'hash' ? <a href={choice.to} className={cls} data-id="element-118" data-mp="vzteuxihrcg0">
                        {content}
                      </a> : <Link to={choice.to} className={cls} data-id="element-119" data-mp="ma9wru2lrmm7">
                        {content}
                      </Link>}
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>

      <div className="relative mx-auto -mt-16 max-w-7xl px-5 lg:px-8" data-id="element-120" data-mp="1esfbvl54x926">
        <dl className="grid gap-px overflow-hidden rounded-3xl bg-line shadow-[0_20px_50px_-30px_rgba(3,59,74,0.45)] ring-1 ring-line sm:grid-cols-3" data-id="element-121" data-mp="19zm3mnagjilc">
          {highlights.map((item, i) => {
          const Icon = highlightIcons[i];
          return <div key={item.title} className="flex items-start gap-4 bg-white p-6 lg:p-7" data-id="element-122" data-mp="kkggzm86b7md" data-mpi={i}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-soft text-primary" data-id="element-123" data-mp="pj9rd5s5yiib">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-124" data-mp="1d8m3oeisf6ou" />
                </span>
                <div data-id="element-125" data-mp="1i8gqo6zfzc4m">
                  <dt className="font-display text-lg font-semibold text-ink" data-id="element-126" data-mp="1i6njmqkx2pw3">{item.title}</dt>
                  <dd className="mt-1 text-sm leading-relaxed text-muted" data-id="element-127" data-mp="13i186zyeuia5">{item.text}</dd>
                </div>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}